var _rect, _rect2, _rect3, _line, _line2, _line3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#E2E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 78,
    width: 169,
    height: 199,
    rx: 4,
    fill: "#B9BFC2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 74,
    width: 168,
    height: 199,
    rx: 3.5,
    fill: "white",
    stroke: "#727E84"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 124,
    x2: 235,
    y2: 124,
    stroke: "#727E84"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 173,
    x2: 235,
    y2: 173,
    stroke: "#727E84"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 222,
    x2: 235,
    y2: 222,
    stroke: "#727E84"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 85.5,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#9CA5A9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 104.5,
    width: 42,
    height: 8,
    rx: 4,
    fill: "#D5D8DA"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 135.5,
    width: 38,
    height: 13,
    rx: 6.5,
    fill: "#9CA5A9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 154.5,
    width: 35,
    height: 8,
    rx: 4,
    fill: "#D5D8DA"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 184.5,
    width: 21,
    height: 13,
    rx: 6.5,
    fill: "#9CA5A9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 233.5,
    width: 31,
    height: 13,
    rx: 6.5,
    fill: "#9CA5A9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 203,
    width: 27,
    height: 8,
    rx: 4,
    fill: "#D5D8DA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 252.5,
    width: 61,
    height: 8,
    rx: 4,
    fill: "#D5D8DA"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 87,
    width: 21,
    height: 10,
    rx: 5,
    stroke: "#B9BFC2",
    strokeWidth: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 137,
    width: 39,
    height: 10,
    rx: 5,
    stroke: "#B9BFC2",
    strokeWidth: 3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 186,
    width: 35,
    height: 10,
    rx: 5,
    stroke: "#B9BFC2",
    strokeWidth: 3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 116.5,
    y: 235,
    width: 31,
    height: 10,
    rx: 5,
    stroke: "#B9BFC2",
    strokeWidth: 3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 93.5,
    width: 42,
    height: 13,
    rx: 6.5,
    fill: "#D5D8DA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 142.5,
    width: 24,
    height: 13,
    rx: 6.5,
    fill: "#D5D8DA"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 191.5,
    width: 35,
    height: 13,
    rx: 6.5,
    fill: "#D5D8DA"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 240.5,
    width: 24,
    height: 13,
    rx: 6.5,
    fill: "#D5D8DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28C16 21.3726 21.3726 16 28 16V16C34.6274 16 40 21.3726 40 28V28C40 34.6274 34.6274 40 28 40V40C21.3726 40 16 34.6274 16 28V28Z",
    fill: "#424E54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 34H24.1328V32.6094L27.0781 29.6484C27.9479 28.7578 28.5234 28.1276 28.8047 27.7578C29.0911 27.3828 29.2995 27.0312 29.4297 26.7031C29.5599 26.375 29.625 26.0234 29.625 25.6484C29.625 25.1328 29.4688 24.7266 29.1562 24.4297C28.849 24.1328 28.4219 23.9844 27.875 23.9844C27.4375 23.9844 27.013 24.0651 26.6016 24.2266C26.1953 24.388 25.724 24.6797 25.1875 25.1016L24.1953 23.8906C24.8307 23.3542 25.4479 22.974 26.0469 22.75C26.6458 22.526 27.2839 22.4141 27.9609 22.4141C29.0234 22.4141 29.875 22.6927 30.5156 23.25C31.1562 23.8021 31.4766 24.5469 31.4766 25.4844C31.4766 26 31.3828 26.4896 31.1953 26.9531C31.013 27.4167 30.7292 27.8958 30.3438 28.3906C29.9635 28.8802 29.3281 29.5443 28.4375 30.3828L26.4531 32.3047V32.3828H31.875V34Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93 45V191H118L93 207L210.5 198H253.5",
    stroke: "#0088F2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93 21.5C88 21.5 83.73 24.61 82 29C83.73 33.39 88 36.5 93 36.5C98 36.5 102.27 33.39 104 29C102.27 24.61 98 21.5 93 21.5ZM93 34C90.24 34 88 31.76 88 29C88 26.24 90.24 24 93 24C95.76 24 98 26.24 98 29C98 31.76 95.76 34 93 34ZM90 29C90 27.34 91.34 26 93 26C94.66 26 96 27.34 96 29C96 30.66 94.66 32 93 32C91.34 32 90 30.66 90 29Z",
    fill: "#0088F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 191,
    r: 4,
    fill: "#0088F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 142,
    r: 4,
    fill: "#0088F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 92,
    r: 4,
    fill: "#0088F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 191,
    r: 4,
    fill: "#0088F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 207,
    r: 4,
    fill: "#0088F2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 198,
    r: 4,
    fill: "#0088F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 57L93 62L98 57",
    stroke: "#0088F2",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242 203L247 198L242 193",
    stroke: "#0088F2",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.71 203.99C265.53 203.84 263 201.22 263 198C263 194.69 265.69 192 269 192C272.22 192 274.84 194.53 274.99 197.71L272.89 197.08C272.48 195.31 270.89 194 269 194C266.79 194 265 195.79 265 198C265 199.89 266.31 201.48 268.08 201.89L268.71 203.99ZM279 198C279 198.3 278.99 198.6 278.96 198.9L276.99 198.31C277 198.21 277 198.1 277 198C277 193.58 273.42 190 269 190C264.58 190 261 193.58 261 198C261 202.42 264.58 206 269 206C269.1 206 269.21 206 269.31 205.99L269.9 207.96C269.6 207.99 269.3 208 269 208C263.48 208 259 203.52 259 198C259 192.48 263.48 188 269 188C274.52 188 279 192.48 279 198ZM275.23 202.26L279 201L269 198L272 208L273.26 204.23L277.53 208.5L279.51 206.52L275.23 202.26Z",
    fill: "#0088F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadList);
export default __webpack_public_path__ + "static/media/read-list.73f1ed8bf57582890d000f63fd10fe72.svg";
export { ForwardRef as ReactComponent };